import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Navigate, Route, Routes as Switch } from 'react-router-dom';
import { If } from '~/components';
import { FluidTheme, isEmpty } from '~/modules';
import {
  AccountDetails,
  AddBalance,
  ClientAccounts,
  ClientRegister,
  ClientSearch,
  Clients,
  CompanyRegister,
  Exports,
  Login,
  ProductDetails,
  ProductRegister,
  Products,
  ProductsPermission,
  SideAccountRegister,
  UpdateLimit,
  Uploads,
  UploadsDetails,
  UserActivationError,
  UserDetails,
  Users,
} from '~/scenes';
import { Storage } from '~/services';
import { showAlert, useStores } from '~/utils';
import { Routes } from './routing';

const RoutesContainer: React.FC = () => {
  const {
    user: { isLogged, getUserLogged },
    theme: { theme },
  } = useStores();
  const tokenStorage = Storage.getToken();
  const [token, setToken] = useState<Token>(tokenStorage);
  const [themeVerificated, setThemeVerificated] = useState<FluidTheme>(theme);

  const getUserDetails = async () => {
    try {
      await getUserLogged();
    } catch ({ message }) {
      showAlert({ message });
    }
  };

  useEffect(() => {
    if (token) {
      getUserDetails();
    }
  }, [token]);

  useEffect(() => {
    setToken(tokenStorage);
    setThemeVerificated(theme);
  }, [isLogged, theme]);

  return (
    <If condition={!isEmpty(themeVerificated)}>
      <Switch>
        {isEmpty(token) && (
          <>
            <Route path="*" element={<Navigate to={Routes.LOGIN} />} />
            <Route path={Routes.LOGIN} element={<Login />} />
            <Route
              path={Routes.USER_ACTIVATION_ERROR}
              element={<UserActivationError />}
            />
          </>
        )}
        {!isEmpty(token) && (
          <>
            <Route path="*" element={<Navigate to={Routes.CLIENTS} />} />
            <Route path={Routes.CLIENTS} element={<Clients />} />
            <Route
              path={Routes.COMPANY_REGISTER}
              element={<CompanyRegister />}
            />
            <Route path={Routes.CLIENT_REGISTER} element={<ClientRegister />} />
            <Route path={Routes.CLIENT_SEARCH} element={<ClientSearch />} />
            <Route path={Routes.CLIENT_ACCOUNTS} element={<ClientAccounts />} />
            <Route
              path={Routes.CLIENT_ACCOUNT_DETAILS}
              element={<AccountDetails />}
            />
            <Route path={Routes.ADD_BALANCE} element={<AddBalance />} />
            <Route path={Routes.UPDATE_MILIT} element={<UpdateLimit />} />
            <Route
              path={Routes.SIDE_ACCOUNT_REGISTER}
              element={<SideAccountRegister />}
            />
            <Route path={Routes.USERS} element={<Users />} />
            <Route path={Routes.USER_DETAILS} element={<UserDetails />} />
            <Route
              path={Routes.PRODUCTS_PERMISSION}
              element={<ProductsPermission />}
            />
            <Route path={Routes.PRODUCTS} element={<Products />} />
            <Route
              path={Routes.PRODUCT_REGISTER}
              element={<ProductRegister />}
            />
            <Route path={Routes.PRODUCT_DETAILS} element={<ProductDetails />} />
            <Route path={Routes.FILES} element={<Uploads />} />
            <Route path={Routes.FILES_DETAILS} element={<UploadsDetails />} />
            <Route path={Routes.EXPORTS} element={<Exports />} />
          </>
        )}
      </Switch>
    </If>
  );
};

export { Routes };
export default observer(RoutesContainer);
